export const CLEAR_FOOTER_ALERT_STATE = 'CLEAR_FOOTER_ALERT_STATE';
export const SET_FOOTER_ALERT = 'SET_FOOTER_ALERT';
export const CLEAR_FOOTER_ALERT = 'CLEAR_FOOTER_ALERT';
export function clearFooterAlertState() {
    return {
        type: CLEAR_FOOTER_ALERT_STATE
    };
}
export function setFooterAlert(alert) {
    return {
        type: SET_FOOTER_ALERT,
        payload: alert
    };
}
export function clearFooterAlert() {
    return {
        type: CLEAR_FOOTER_ALERT
    };
}
